export default "__VITE_ASSET__c16c06af__"